import { render } from "./BookingTransportForm.vue?vue&type=template&id=47038b0a&scoped=true"
import script from "./BookingTransportForm.vue?vue&type=script&lang=js"
export * from "./BookingTransportForm.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-47038b0a"

export default script